import * as React from 'react';
import { LatestNewsPublishDateContainer, LatestNewsPublishDateContent } from './components';

export const LatestNewsPublishDate = (props: {
  id: string,
}) => {
  const {
    id,
  } = props;
  return (
    <LatestNewsPublishDateContainer>
      <LatestNewsPublishDateContent id={id} />
    </LatestNewsPublishDateContainer>
  );
};
